<template>
  <a class="row align-items-center mb-3" :href="task.detailsPageUrl">
    <div class="col">
      <div class="admin-task-title">{{ task.title }}</div>
      <div class="admin-task-subtitle" v-if="task.totalScreenshots > 0">
        <span style="margin-right: 8px;"><TaskIcon/></span>
        <span class="font-weight-bold" style="margin-right: 4px;">{{ task.totalScreenshots }}</span> screenshots |

        <span class="admin-task-subtitle" v-if="task.assignee">by {{ displayAssignees(task.assignee) }}</span>
      </div>
    </div>
    <div class="col col-auto">
      <div class="admin-task-time">
        {{ minutesToHoursFormatter(task.totalTime) }}
        <span class="task-cost" v-if="isCompleted">({{ moneyCurrencyFormatting(task.totalCost) }})</span>
      </div>
    </div>
    <div class="col col-auto">
      <task-status-badge :status="task.status"></task-status-badge>
    </div>
  </a>
</template>

<script>
import minutesToHoursFormatter from '../utils/minutesToHoursFormatter';
import moneyCurrencyFormatting from '../utils/moneyCurrencyFormatting';
import TaskIcon from '../icons/Tasks/TaskIcon';

export default {
  components: { TaskIcon },
  props: {
    task: {
      required: true,
      type: Object,
    },
  },

  computed: {
    isCompleted () {
      return this.task.status === 'completed';
    },
  },

  methods: {
    minutesToHoursFormatter,

    moneyCurrencyFormatting,

    displayAssignees (assignees) {
      return assignees.map((assignee) => {
        return assignee.display_name ?? assignee.name;
      }).join(', ');
    },
  },
};
</script>

<style scoped lang="scss">
.admin-task-title {
  color: #303030;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
}

.admin-task-subtitle {
  color: #8997aa;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 22px;
}

.admin-task-time {
  color: #8997aa;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
  text-align: right;

  .task-cost {
    display: inline;
    font-weight: bold;
    color: #0b1324;
  }
}
</style>
